import { BrowserModule, Title } from '@angular/platform-browser';
import { NgModule, LOCALE_ID  } from '@angular/core';
import { APP_BASE_HREF } from '@angular/common';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { OverlayContainer} from '@angular/cdk/overlay';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { ToastrModule } from 'ngx-toastr';
import { CalendarModule, DateAdapter } from 'angular-calendar';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { adapterFactory } from 'angular-calendar/date-adapters/date-fns';


import { ReactiveFormsModule } from '@angular/forms';
import { DatePipe } from '@angular/common';
import { CoreMaterialModule } from './core/core.material.module';
import { CommonComponentModule } from './common/common.component.module';
import { CoreModule } from './core/core.module';
import { ServicesModule } from './services/services.module';
import { AppRouteModule } from './app.route.module';

import { AppComponent } from './app.component';
import { PageNotFoundComponent } from './page.not.found.component';


export function HttpTranslateLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@NgModule({
  declarations: [
    AppComponent,
    PageNotFoundComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    CoreMaterialModule,
    NgxDatatableModule,
    ReactiveFormsModule,
    AppRouteModule,

    //NgxPrintModule,
    CoreModule.forRoot(),
    CommonComponentModule,
    ServicesModule.forRoot(),
    ToastrModule.forRoot({
      maxOpened: 5,
      autoDismiss: true,
      newestOnTop: true,
      preventDuplicates: false
    }),
    TranslateModule.forRoot({
      loader: {
          provide: TranslateLoader,
          useFactory: HttpTranslateLoaderFactory,
          deps: [HttpClient]
      }
    }),
    CalendarModule.forRoot({
      provide: DateAdapter,
      useFactory: adapterFactory
    })
  ],
  providers: [
    Title,
    DatePipe,
    { provide: LOCALE_ID, useValue: 'en-gb' },
    { provide: APP_BASE_HREF, useValue: window['base-href'] }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
  constructor (overlayContainer: OverlayContainer) {
    overlayContainer.getContainerElement().classList.add('tv-light-theme');
  }
 }
